<template>
  <div :class="['sale-badge', { 'sale-badge--large' : isLarge }]">
    <span :class="['sale-badge__discount', { 'sale-badge__discount--long' : showEndsSoon || showEndsToday }, { 'sale-badge__discount--large' : isLarge }]">
      {{ percentageDiscount }} OFF
    </span>
    <span v-if="saleTag" :class="['sale-badge__tag', { 'sale-badge__tag--large' : isLarge }]">
      {{ saleTag }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    percentageDiscount: String,
    showEndsSoon: Boolean,
    showEndsToday: Boolean,
    isLarge: Boolean,
  },
  computed: {
    saleTag() {
      if (this.showEndsSoon) {
        return 'ENDS SOON'
      }

      if (this.showEndsToday) {
        return 'ENDS TODAY'
      }

      return false
    }
  }
}
</script>

<style lang="scss">
@use "~/common/scss/helpers";

.sale-badge {
  display: flex;
  flex-direction: column;
  font-size: helpers.px-to-rem(13);
  font-weight: 600;
  position: absolute;
  top: 0;
  right: 0;
  opacity: var(--child-opacity);
  transition: opacity .25s;

  &--large {
    width: helpers.px-to-rem(117);
    font-size: helpers.px-to-rem(20);
  }

  &__discount {
    width: 100%;
    color: #fff;
    background: #E6421A;
    height: helpers.px-to-rem(32);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: helpers.px-to-rem(10);
    padding-right: helpers.px-to-rem(10);

    &--large {
      height: helpers.px-to-rem(43);
    }

    &--long {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
  &__tag {
    font-size: helpers.px-to-rem(10);
    color: #FFF;
    background: #000;
    height: helpers.px-to-rem(16);
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;

    &--large {
      height: helpers.px-to-rem(29);
      font-size: helpers.px-to-rem(13);
    }
  }
}

swiper-slide .sale-badge {
  right: 20px;
}
</style>